export default {
  ChooseFile: 'Choose file',
  Uploading: 'Uploading',
  AreYouSureToRemoveThisFile: 'Are you sure to remove this file?',
  HasError: 'Validation Error!',
  File_max_size_exceeded:
    'File max size exceeded for "{fileName}". Upload files smaller than {maxSize} KB.',
  File_extension_not_accepted:
    'File type is not accepted for "{fileName}". Accepted Types are "{accepted}".',
  jalaliCal: 'Jalali Calendar',
  gregorianCal: 'Gregorian Calendar',
  Preview: 'Preview',
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
  lastWeekDay: '[Last] dddd',
  noTimeSelected: 'No time selected',
  squareImageError: {
    single: 'Image width and height should be equal',
    multiple:
      'One or more of images width and height is not equal, not uploaded'
  },
  uploadCountLimit:
    'The number of selected files must be less than or equal to {count}',
  countOfItemsFound: '{count} items found',
  notFilterDescription: {
    enable: 'Disable not mode',
    disable: 'Enable not mode'
  },
  loading: 'Loading ...',
  applFilter: 'Apply filter',
  removeFilters: 'Remove filters',
  excelExport: 'Excel export',
  searchCourier: 'Search courier',
  search: 'Search',
  searchUser: 'Search user',
  choose: 'Choose ...',
  clientType: 'Client type',
  lastUpdate: 'Last update',
  nothingFound: 'Nothing found',
  bulkImport: 'Bulk import',
  sampleFile: 'Sample file',
  excelFile: 'Excel file',
  saveChanges: 'Save changes',
  dateRangeRequired: 'Date range required',
  files: 'Files'
}
